const validate = (value,  options) => {
  if (options.hidden){
    return !checkArray(value, options.exclusion);
  }
  return !options.hidden;
};

let checkArray = function (value, options) {
  return options.some(function (item) {
    // eslint-disable-next-line
    return item == value;
  });
};

export {
  validate
};
export default {
  validate
};



//////////////////
// WEBPACK FOOTER
// ./static/resources/Rules/hiddenExcluded.js
// module id = +fB6
// module chunks = 39